import {
  call, put, select, takeEvery, takeLatest,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import findResult from '@/utils/resultsHelper';
import selectors from '@/selectors';
import { workspaceForms } from '@/workspaces/constants';
import { showWorkspaceFormError } from '@/workspaces/actions';
import { readStates, states } from '@/constants/lifecycle';
import WorkflowsService from '@/workflows/service';
import { addWorkspaceRequestFieldsToSections } from '@/workspaces/state/state';
import WorkspacesService from '@/workspaces/service';
import { showWorkflowRequestError } from '../../actions';
import {
  showRequestLocations,
  showRequestLocationsError,
  showRequestWorkspace,
  showRequestWorkspaceError,
  showRequestWorkspaces,
  showRequestWorkspacesError,
  showFormForWorkspaceRequest,
  showWorkspaceFormForRequest,
} from '../actions';
import actions from '../constants';
import requestActions from '../../constants';
import RequestWorkspaceService from '../service';

export function* workspaces({ category, code, location }) {
  const items = yield select(selectors.requests);
  const item = findResult(items, category, code);
  const { response, error } = yield call(callAdapter, WorkspacesService.workspaces(
    item.request_source,
    item.steps.results[0].code,
    location,
  ));

  if (error) {
    yield put(showRequestWorkspacesError(category, code, error));
  } else {
    yield put(showRequestWorkspaces(category, code, response.items));
  }
}

export function* workspace({ code }) {
  const { response, error } = yield call(callAdapter, RequestWorkspaceService.workspace(code));

  if (error) {
    yield put(showRequestWorkspaceError(code, error));
  } else {
    yield put(showRequestWorkspace(code, response));
  }
}

export function* FormForWorkspaceRequest({ code, intl }) {
  const { response, error } = yield call(callAdapter, WorkspacesService.workspacesForm(workspaceForms.REQUEST));
  if (error) {
    yield put(showWorkspaceFormError('workspaces', workspaceForms.REQUEST, error));
  } else {
    addWorkspaceRequestFieldsToSections(response, intl);
    yield put(showFormForWorkspaceRequest(code, response));
  }
}

function* showWorkspaceFormForRequestExtended(category, requestCode, intl, workspaceForm, workflow) {
  addWorkspaceRequestFieldsToSections(workspaceForm, intl);
  yield put(showWorkspaceFormForRequest(category, requestCode, workspaceForm, workflow));
}

function* workflowForRequest(category, code, requestCode, intl, workspaceForm) {
  const { response, error } = yield call(callAdapter, WorkflowsService.workflow(code));

  if (error) {
    yield put(showWorkflowRequestError(category, code, requestCode, error));
  } else {
    yield call(showWorkspaceFormForRequestExtended, category, requestCode, intl, workspaceForm, response);
  }
}

export function* workspaceFormForRequest({ category, code, intl }) {
  const requests = yield select(selectors.requests);
  const workflows = yield select(selectors.workflows);
  const request = findResult(requests, category, code);
  const [source] = request.steps.results;
  const workflow = findResult(workflows, category, source.settings.workflow_key) || { ...readStates };
  const { response, error } = yield call(callAdapter, WorkspacesService.workspacesForm(workspaceForms.REQUEST));

  if (error) {
    yield put(showWorkspaceFormError('workspaces', workspaceForms.REQUEST, error));
  } else if ([states.PENDING, states.NONE].includes(workflow.readStatus)) {
    yield call(workflowForRequest, category, source.settings.workflow_key, code, intl, response);
  } else {
    yield call(showWorkspaceFormForRequestExtended, category, code, intl, response, workflow);
  }
}

export function* workspaceLocations({ category, code }) {
  const items = yield select(selectors.requests);
  const item = findResult(items, category, code);
  const { response, error } = yield call(callAdapter, WorkspacesService.workspacesLocations(
    item.request_source,
    item.steps.results[0].code,
  ));

  if (error) {
    yield put(showRequestLocationsError(category, code, error));
  } else {
    yield put(showRequestLocations(category, code, response.items));
  }
}

export default function* requestWorkspacesApi() {
  yield takeEvery(actions.FETCH_REQUEST_LOCATIONS, workspaceLocations);
  yield takeEvery(actions.FETCH_REQUEST_WORKSPACE, workspace);
  yield takeEvery(actions.FETCH_REQUEST_WORKSPACES, workspaces);
  yield takeLatest(requestActions.SHOW_TRANSFER_REQUEST, workspace);
  yield takeEvery(actions.FETCH_FORM_FOR_WORKSPACE_REQUEST, FormForWorkspaceRequest);
  yield takeEvery(actions.FETCH_WORKSPACE_FORM_FOR_REQUEST, workspaceFormForRequest);
}
